import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ScriptLoaderService, ClassService, DashboardService } from '../../../../../_services';

@Component({
    selector: "app-index-contract",
    templateUrl: "./index-contract.component.html",
    providers: [DashboardService]
})
export class IndexContractComponent implements OnInit, AfterViewInit {

    data: any;
    static initialClass: string =
    'm-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    constructor(
        private _script: ScriptLoaderService,
        private _classService: ClassService,
        private _dashboardService: DashboardService) {

    }

    ngOnInit() {
        this._dashboardService.getContract().subscribe(data => {
            this.data = data;
        });

    }
    ngAfterViewInit() {
        this._classService.setClass(document.body, IndexContractComponent.initialClass);

    }

    clear() {
    }

    search() {
    }


}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/index/index-contract/index-contract.component.ts